module.exports = __webpack_public_path__ + "static/order_domain-9cb5ccdf21816e0b8428f27065a0c5a3.png";